import {
    DEALERGETLISTDSRTRANSACTION_SUCCESS,
    DEALERGETLISTDSRTRANSACTION_FAILED,
    RESET_DEALERGETLISTDSRTRANSACTION,
    LOADING_DEALERGETLISTDSRTRANSACTION,
    NETWORK_ERROR_DEALERGETLISTDSRTRANSACTION
} from '../types/index'
import { dealerServices } from "../../config/axios";

const resetDealerGetListDsrTransaction = () => {
    return { type: RESET_DEALERGETLISTDSRTRANSACTION };
};

const dealerGetListDsrTransaction = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERGETLISTDSRTRANSACTION });
    await dealerServices
        .post("dsrTransaction", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerGetListDsrTransactionsuccess(res.data));
                    break;
                default:
                    dispatch(dealerGetListDsrTransactionFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERGETLISTDSRTRANSACTION,
                payload: err
            });
        });
}
function dealerGetListDsrTransactionsuccess(data) {
    return {
        type: DEALERGETLISTDSRTRANSACTION_SUCCESS,
        payload: data
    };
}

function dealerGetListDsrTransactionFailed(data) {
    return {
        type: DEALERGETLISTDSRTRANSACTION_FAILED,
        payload: data
    };
}
export { resetDealerGetListDsrTransaction, dealerGetListDsrTransaction }